<div class="get-in-touch">
  <div class="get-in-touch__icons">
    <button
      matTooltip="Talk to Us"
      matTooltipPosition="right"
      [matMenuTriggerFor]="agentCallMenu">
      <span class="material-icons"> support_agent </span>
    </button>
    <button
      matTooltip="Send us a query"
      matTooltipPosition="right"
      [matMenuTriggerFor]="emailMenu">
      <span class="material-icons"> mail_outline </span>
    </button>
    <button
      matTooltip="Help Topics"
      matTooltipPosition="right"
      (click)="goToHelpTopics()">
      <span class="material-icons"> help_outline </span>
    </button>
  </div>
  <mat-menu #agentCallMenu="matMenu" class="git-menu callMenu">
    <div class="get-in-touch__cont" (click)="$event.stopPropagation()">
      <div class="call-block">
        <h4>Call</h4>
        <p>
          It will be a pleasure to assist you by phone, Monday through Friday
          from 8:00 a.m. to 9:00 p.m. at:
        </p>
        <strong>1800 983 2383</strong>
      </div>
    </div>
  </mat-menu>
  <mat-menu #emailMenu="matMenu" class="git-menu email">
    <div class="get-in-touch__cont" (click)="$event.stopPropagation()">
      <div class="email-block">
        <h4>Email</h4>
        <p class="pa-2">
          We will be happy to assist you from
          <span class="d-block"
            >Monday to Friday from 9:00 a.m. to 8:00 p.m.</span
          >
        </p>
        <form class="example-form" [formGroup]="userSupportForm">
          <div class="get-in-touch__scroll">
            <div class="pt-1">
              <mat-form-field
                class="custom-form-control light"
                appearance="outline">
                <mat-label>First Name</mat-label>
                <input matInput formControlName="firstName" tabindex="0" />
              </mat-form-field>
              <div
                class="mb-1"
                *ngIf="f['firstName'].invalid && f['firstName'].dirty">
                <span
                  class="error-msg"
                  *ngIf="f['firstName']?.hasError('required')">
                  First Name is required.
                </span>
                <span
                  class="error-msg"
                  *ngIf="f['firstName']?.hasError('minlength')">
                  First Name must have at least 3 characters.
                </span>
                <span
                  class="error-msg"
                  *ngIf="f['firstName']?.hasError('maxlength')">
                  First Name exceeding 40 characters.
                </span>
                <span
                  class="error-msg"
                  *ngIf="f['firstName']?.hasError('pattern')">
                  Alphabets and following special characters, ".","'","-" are
                  allowed.
                </span>
              </div>
            </div>
            <div>
              <mat-form-field
                class="custom-form-control light"
                appearance="outline">
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="lastName" tabindex="0" />
              </mat-form-field>
              <div
                class="mb-1"
                *ngIf="f['lastName'].invalid && f['lastName'].dirty">
                <span
                  class="error-msg"
                  *ngIf="f['lastName']?.hasError('minlength')">
                  Last Name must have at least 3 characters.
                </span>
                <span
                  class="error-msg"
                  *ngIf="f['lastName']?.hasError('maxlength')">
                  Last Name exceeding 40 characters.
                </span>
                <span
                  class="error-msg"
                  *ngIf="f['lastName']?.hasError('pattern')">
                  Alphabets and following special characters, ".","'","-" are
                  allowed.
                </span>
              </div>
            </div>
            <div>
              <mat-form-field
                class="custom-form-control light"
                appearance="outline">
                <mat-label>Email Address</mat-label>
                <input matInput formControlName="email" tabindex="0" />
              </mat-form-field>
              <div class="mb-1" *ngIf="f['email'].invalid && f['email'].dirty">
                <span
                  class="error-msg"
                  *ngIf="f['email']?.hasError('required')">
                  Email Address is required.
                </span>
                <span
                  class="error-msg mb-1"
                  *ngIf="f['email']?.hasError('pattern')">
                  Invalid Email Address.
                </span>
              </div>
            </div>
            <div class="mobile-field">
              <div class="prefix light">(+001)</div>
              <mat-form-field
                class="custom-form-control light required"
                appearance="outline">
                <mat-label>Mobile Number </mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="contact"
                  tabindex="0" />
              </mat-form-field>
            </div>
            <span
              class="error-msg mb-1"
              *ngIf="
                (f['contact']?.dirty &&
                  (f['contact']?.hasError('minlength') ||
                    f['contact']?.hasError('maxlength'))) ||
                f['contact']?.hasError('pattern')
              ">
              Invalid Mobile number.
            </span>
            <div>
              <mat-form-field
                class="custom-form-control light"
                appearance="outline">
                <mat-label>Subject</mat-label>
                <input matInput formControlName="subject" tabindex="0" />
              </mat-form-field>
              <div
                class="mb-1"
                *ngIf="f['subject'].invalid && f['subject'].dirty">
                <span
                  class="error-msg"
                  *ngIf="f['subject']?.hasError('required')">
                  Subject is required.
                </span>
                <span
                  class="error-msg"
                  *ngIf="f['subject']?.hasError('minlength')">
                  Subject must have at least 3 characters.
                </span>
                <span
                  class="error-msg"
                  *ngIf="f['subject']?.hasError('maxlength')">
                  Subject exceeding 200 characters.
                </span>
                <span
                  class="error-msg"
                  *ngIf="f['subject']?.hasError('pattern')">
                  Alphabets and following special characters, ".","'","-" are
                  allowed.
                </span>
              </div>
            </div>
            <div>
              <mat-form-field
                class="custom-form-control light textarea"
                appearance="outline">
                <mat-label>Message</mat-label>
                <textarea
                  matInput
                  formControlName="message"
                  tabindex="0"></textarea>
                <mat-hint align="end">
                  {{ f['message'].value?.length }} / 200
                </mat-hint>
              </mat-form-field>
              <div class="mb-1">
                <span
                  class="error-msg"
                  *ngIf="f['message']?.hasError('minlength')">
                  Message must have at least 3 characters.
                </span>
                <span
                  class="error-msg mb-1"
                  *ngIf="f['message']?.hasError('maxlength')">
                  Message exceeding 200 characters.
                </span>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button
              class="primary-btn"
              type="submit"
              (click)="submitForm()"
              [disabled]="userSupportForm.invalid">
              Submit
              <div *ngIf="isLoading" class="spinner ml-1">
                <mat-spinner [diameter]="20"></mat-spinner>
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>
  </mat-menu>
</div>
